import ValidationUtil from '../../../definitions/validation/ValidationUtil';
import { TestAppContext } from '../../../definitions/_tests/TestAppContext';
/**
 * This class validates an instance of InlineDialogProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */
var InlineDialogProviderValidator = /** @class */ (function () {
    function InlineDialogProviderValidator() {
    }
    InlineDialogProviderValidator.validate = function (inlineDialogProvider) {
        ValidationUtil.checkFunctionExists('inlineDialogProvider', inlineDialogProvider, 'hide');
        var appContext = TestAppContext.buildNewInstance();
        inlineDialogProvider.hide(appContext);
    };
    return InlineDialogProviderValidator;
}());
export { InlineDialogProviderValidator };
//# sourceMappingURL=InlineDialogProviderValidator.js.map